import {
  arrayPrototype,
  getPrototypeOf,
  isTerminateValue,
  mapPrototype,
  objectPrototype,
  setPrototype,
  weakMapPrototype,
  weakSetPrototype
} from '@rehaje/shared'

import { DEEP, PROXY, SHALLOW, TERMINATE } from './flags'
import { arrayHandlers, collectionHandlers, objectHandlers } from './handlers'

import type { Reactive } from './types'

export function createProxy<T = any>(value?: T): T
export function createProxy(value: Reactive) {
  let flags: number
  let proto: object
  if (isTerminateValue(value)) return value
  if ((flags = value.__rr_flags) & TERMINATE) {
    if (flags & (TERMINATE ^ PROXY)) return value
    if (flags & DEEP && (value === value.__rr_raw || value === value.__rr_deep))
      return value.__rr_deep
    if (
      flags & SHALLOW &&
      (value === value.__rr_raw || value === value.__rr_shallow)
    )
      return value.__rr_shallow
    return value
  }
  if ((proto = getPrototypeOf(value)) === objectPrototype) {
    const proxy = new Proxy(value, objectHandlers)
    value.__rr_raw = value
    value.__rr_deep = proxy
    value.__rr_flags |= DEEP
    return proxy
  }
  if (proto === arrayPrototype) {
    const proxy = new Proxy(value, arrayHandlers)
    value.__rr_raw = value
    value.__rr_deep = proxy
    value.__rr_flags |= DEEP
    return proxy
  }
  if (
    proto === mapPrototype ||
    proto === setPrototype ||
    proto === weakMapPrototype ||
    proto === weakSetPrototype
  ) {
    const proxy = new Proxy(value, collectionHandlers)
    value.__rr_raw = value
    value.__rr_deep = proxy
    value.__rr_flags |= DEEP
    return proxy
  }
  return value
}

export function createShallowProxy<T = any>(value?: T): T
export function createShallowProxy(value: Reactive) {
  let flags: number
  let proto: object
  if (isTerminateValue(value)) return value
  if ((flags = value.__rr_flags) & TERMINATE) {
    if (flags & (TERMINATE ^ PROXY)) return value
    if (flags & DEEP && (value === value.__rr_raw || value === value.__rr_deep))
      return value.__rr_deep
    if (
      flags & SHALLOW &&
      (value === value.__rr_raw || value === value.__rr_shallow)
    )
      return value.__rr_shallow
    return value
  }
  if ((proto = getPrototypeOf(value)) === objectPrototype) {
    const proxy = new Proxy(value, objectHandlers)
    value.__rr_raw = value
    value.__rr_shallow = proxy
    value.__rr_flags |= SHALLOW
    return proxy
  }
  if (proto === arrayPrototype) {
    const proxy = new Proxy(value, arrayHandlers)
    value.__rr_raw = value
    value.__rr_shallow = proxy
    value.__rr_flags |= SHALLOW
    return proxy
  }
  if (
    proto === mapPrototype ||
    proto === setPrototype ||
    proto === weakMapPrototype ||
    proto === weakSetPrototype
  ) {
    const proxy = new Proxy(value, collectionHandlers)
    value.__rr_raw = value
    value.__rr_shallow = proxy
    value.__rr_flags |= SHALLOW
    return proxy
  }
  return value
}
